export const AreaOfOperationCodes = {
    landMobileControlStation: 'X',
};
